// Point d'entrée de l'application compilée (esbuild).
// Étape d : personne n'entre dans l'ERP sans connexion complète (mot de passe + double authentification).
import React from "react";
import { createRoot } from "react-dom/client";
import { installerStockageServeur } from "./stockage-serveur.js";
import { creerSession } from "./session.js";
import Connexion from "./connexion.jsx";
import ERP, { LOGO_SRC, reglerModeProduction } from "./app.jsx";

installerStockageServeur(window);
const session = creerSession();
const racine = createRoot(document.getElementById("root"));

let configLue = false;
async function demarrer() {
  // Étape h : mode production (plus de bouton de développement, ni import, ni « Vider les données »).
  if (!configLue) {
    try {
      const config = await (await fetch("/api/config")).json();
      reglerModeProduction(!!config.production);
    } catch (e) {
      reglerModeProduction(true); // serveur muet : on reste prudent
    }
    configLue = true;
  }
  let moi = null;
  try {
    moi = await session.moi();
  } catch (e) {
    moi = null;
  }
  if (moi && moi.etape === "complete") {
    racine.render(<ERP compteConnecte={moi.compte} session={session} />);
    return;
  }
  // Connexion pas terminée (ex. page rechargée pendant la double authentification) : on reprend à son étape.
  const etape = moi ? (moi.etape === "complete" ? "identifiant" : moi.etape) : "identifiant";
  racine.render(<Connexion session={session} etapeInitiale={etape} nom={moi ? moi.compte.nom : ""} logo={LOGO_SRC} onConnecte={demarrer} />);
}
demarrer();
